import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import { Table, Button } from '../../components/index';
import { doGet } from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import * as constantes from '../../utils/constants';
import FiltroCessacao from './FiltroCessacao';
import { manterApenasFiltro } from '../../utils/helpers';


class ConsultaCessacaoBeneficio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRequerimentosFiltrada: null,
      listaRequerimentosIndexada: [],
      requerimentoVindoDoRequest: null,
      tipoRequerimentoSelecionado: null,
      // showCessacaoBeneficioModal: false,
      // requerimentoModalCessacao: {},
      showNoContent: false,
      listaRequerimentosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      tipoRequerimento: null,
      filtrosPesquisa: {},
    };
  }

  componentDidMount() {
    manterApenasFiltro('filtroCessacao');
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    // console.log(this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta);
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  realizaConsulta = (filtrosPesquisa) => {
    // params estados[]: int , cpf : string,
    // tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }
    // Copiar atributos além do filtro
    const atributosConsulta = this.verificaAtributosParaConsulta();
    if (atributosConsulta) {
      if (filtrosConsulta.estado === undefined) {
        filtrosConsulta.estado = atributosConsulta.estados;
      }
      filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;
      // filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
    }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'requerimentos-cessacao',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'unidade-inss': this.lotacao,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRequerimentosIndexada: [], listaRequerimentosIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {
      participacao: atributosPesquisa.participacao,
      'unidade-inss': this.lotacao,
    };
    if (atributosPesquisa.cpf) {
      atributos = { ...atributos, cpf: atributosPesquisa.cpf };
    }
    if (atributosPesquisa.tipoRequerimento) {
      atributos = { ...atributos, 'tipo-requerimento': atributosPesquisa.tipoRequerimento };
    }
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  verificaAtributosParaConsulta = () => {
    if (this.getTipoConsulta()) {
      return constantes.estadosParaConsulta[this.getTipoConsulta()];
    }
    return null;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: [],
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRequerimentosIndexada: response.data,
        listaRequerimentosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRequerimentosFiltrada) => {
    this.setState({ listaRequerimentosFiltrada, listaRequerimentosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  }

  pushNavegacao = (tipo, row) => {
    if (!this.getTipoConsulta()) {
      this.props.history.push(`/requerimento/${tipo}/${row.protocolo}`);
    } else {
      const atributosConsulta = this.verificaAtributosParaConsulta();
      if (tipo && row) {
        this.props.history.push(`/requerimento/${tipo}/${row.protocolo}/${atributosConsulta.acao}`);
      } else {
        this.props.history.push(`/requerimento/${this.state.tipoRequerimentoSelecionado}/${this.state.requerimentoVindoDoRequest.protocolo}/${atributosConsulta.acao}`);
      }
    }
  }

  diffRequerimento = (tipoRequerimento) => {
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  // handleResponseCessacaoRequerimento = (response) => {
  //   // let tipo = 'pensao';
  //   // if (response.data.tipoAposentadoria) {
  //   //   tipo = 'aposentadoria';
  //   // }
  //   const tipo = this.state.tipoRequerimento
  //   this.props.history.push(`/requerimento/
  // cessacao/${tipo}/${response.data.protocolo}/cessar-requerimento`);
  //   // /requerimento/${tipo}/${response.data.protocolo}/cessar-requerimento`
  // }

  showRequerimentoCessacao = (requerimento) => {
    // let tipo = 'pensao';
    // if (requerimento.tipoRequerimento === 1) {
    //   tipo = 'aposentadoria';
    // }
    const tipo = requerimento.tipoRequerimento;
    this.setState({
      tipoRequerimento: requerimento.tipoRequerimento,
    });
    // doGet(
    //   `requerimentos-cessacao-${tipo}/${requerimento.protocolo}`,
    //   this.handleResponseCessacaoRequerimento,
    // );
    this.props.history.push(`/requerimento/cessacao/${tipo}/${requerimento.protocolo}/cessar-requerimento`);
  }

  montaAcoesCessacaoBeneficio = (row, tipo) => (
    <Button
      hint={tipo}
      icon="ico-doc-pencil"
      mini
      // onClick={() => this.showCessacaoBeneficioModal(row, tipo)}
      onClick={() => this.showRequerimentoCessacao(row)}
    />
  );

  createActionColumn = (cell, row) => {
    let tipo = 'pensao';
    if (row.tipoRequerimento === 1) {
      tipo = 'aposentadoria';
    }
    return this.montaAcoesCessacaoBeneficio(row, tipo);
  };

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  colunasDefault = [
    { id: 'cpf', label: 'CPF' },
    { id: 'nome', label: 'Nome' },
    { id: 'matricula', label: 'Matrícula' },
    { id: 'nomeSolicitante', label: 'Solicitante' },
    { id: 'nomeDestinatario', label: 'Destinatário' },
    { id: 'tipoRequerimento', label: 'Tipo', dataFormat: this.addTipoRequerimentoLabel },
    { id: 'estado', label: 'Estado', dataFormat: this.addTipoEstadoLabel },
  ];

  montaColunas = () => {
    const requerimentosExigenciaTableHeader = this.colunasDefault.slice();
    requerimentosExigenciaTableHeader.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return requerimentosExigenciaTableHeader;
  }

  defineListaParaTabela = () => {
    if (this.state.listaRequerimentosFiltrada !== null) {
      return this.state.listaRequerimentosFiltrada;
    }
    return this.state.listaRequerimentosIndexada;
  }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  render() {
    const options = {
      noDataText: 'Nenhum requerimento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const requerimentosExigenciaTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroCessacao
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios={this.props.destinatarios}
            list={this.state.listaRequerimentosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaRequerimentosIndexadaAtualizada={this.state.listaRequerimentosIndexadaAtualizada}
          />
          <Table
            legend="Cessação Manual de Requerimentos"
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={requerimentosExigenciaTableHeader}
            pagination
            remote
          />
        </DtpContentContainer>
      )
    );
  }
}

ConsultaCessacaoBeneficio.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
      tipoRequerimento: PropTypes.number,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
};

ConsultaCessacaoBeneficio.defaultProps = {
  destinatarios: [],
  match: null,
  // exigencias: [],
  auth: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  // exigencias: state.base.exigencias,
});

export default connect(mapStateToProps)(ConsultaCessacaoBeneficio);



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaCessacaoRequerimento.jsx